import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Icon, message } from 'antd'

import Tooltip from './../../dataDisplay/ToolTip'
import InformationIcon from '../../general/icons/InformationIcon'
import './../../ui.style.scss'
import PopoverConfirm from '../../feedback/PopoverConfirm'
import JsonEditor from 'components/ui/dataDisplay/JsonEditor'
import { JASON_EDITOR_OPTIONS_TO_REMOVE, JSON_EDITOR_HEADER_OPTIONS_TO_REMOVE, JSON_EDITOR_INDENTATION } from 'constants/general-constants'
import AddImageModal from 'components/ui/dataEntry/other/AddImageModal'
import { cloneDeep, set } from 'lodash'
import { getJsonEditorArrayValue } from 'components/ui/dataDisplay/utils'

// const { TextArea } = Input

let parentCompoent = 'input-field-json'

// const onChange = (handleChange, event) => {
//   const value = event.target.value
//   if (!value.startsWith(' ')) { handleChange(event) }
// }

const copyOnClick = (data, type) => {
  navigator.clipboard.writeText(data, type)
  message.success(`${type} Copied Successfully`)
}

const TextAreaJsonArrayApp = ({ handleChange, value, placeholder, title, inputName, isEditable, isLimited, limit, onFocus, isRequired, isError, isJsonArrayValid,
  currentId, jsonArrayInvalidEntries, tooltipText, jsonConfig, handleJsonArrayChange, project, jsonEditorValue, mode, handleJsonEditorModes }) => {
  let index = (jsonArrayInvalidEntries || []).indexOf(currentId)
  let jsonError = isError
  let jsonErrorMessage = false
  if (index !== -1) {
    jsonError = true
    jsonErrorMessage = true
  }
  const [isImageModalOpen, setIsImageModalOpen] = useState(false)
  const [imagePathDetails, setImagePathDetails] = useState(null)
  // const [jsonEditorModes, setJsonEditorModes] = useState({})

  const handleOpenImageModal = (flag, context) => {
    if (flag) {
      setIsImageModalOpen(true)
      setImagePathDetails(context.selection)
    } else {
      setIsImageModalOpen(false)
      setImagePathDetails(null)
    }
  }

  const handleContextMenuOptions = ({ items, context, config, selectedMeta, jsonEditorReadOnly }) => {
    let contextMenuItemsNeeded = cloneDeep(items)
    const isValueContextType = context?.selection?.type === 'value'
    // if context menu opened on value type show image option
    // if (isValueContextType) {
    const isTableView = contextMenuItemsNeeded.length === 2
    const isTreeView = !isTableView
    let details = contextMenuItemsNeeded
    const imageOption = {
      type: 'button',
      onClick: () => handleOpenImageModal(true, context, config, selectedMeta),
      // icon: <Plus/>,
      text: '+ Image',
      title: 'Add image',
      disabled: jsonEditorReadOnly || !isValueContextType
    }
    if (isTreeView) {
      details = contextMenuItemsNeeded.map((item, index) => {
        const itemWithCUtCopyEdit = 2
        if (index === itemWithCUtCopyEdit) {
          return {
            type: 'row',
            items: [imageOption]
          }
        } else {
          if (item.type === 'row') {
            return {
              ...item,
              items: item.items.map(rowItem => {
                if (rowItem.type === 'column') {
                  return {
                    ...rowItem,
                    items: rowItem.items.filter(columnItem => {
                      if (JASON_EDITOR_OPTIONS_TO_REMOVE.includes(columnItem.text)) {
                        return false
                      }
                      return true
                    })
                  }
                } else {
                  return rowItem
                }
              })
            }
          } else {
            return item
          }
        }
      })
    }
    if (isTableView) {
      details = contextMenuItemsNeeded.map((item, index) => {
        if (item.type === 'row') {
          return {
            ...item,
            items: item.items.map(rowItem => {
              if (rowItem.type === 'column') {
                let hasTableRow = false
                const filteredColumns = rowItem.items.filter(columnItem => {
                  if (columnItem.text === 'Table row:') {
                    hasTableRow = true
                  }
                  if (JASON_EDITOR_OPTIONS_TO_REMOVE.includes(columnItem?.main?.text) || JASON_EDITOR_OPTIONS_TO_REMOVE.includes(columnItem.text)) {
                    return false
                  }
                  return true
                })
                if (hasTableRow) {
                  filteredColumns.push(imageOption)
                }
                return {
                  ...rowItem,
                  items: filteredColumns
                }
              } else {
                return rowItem
              }
            })
          }
        } else {
          return item
        }
      })
    }
    return details
    // }
    // return contextMenuItemsNeeded
  }

  // const handleJsonEditorModes = (mode, id) => {
  //   setJsonEditorModes(prevState => {
  //     return {
  //       ...prevState,
  //       [id]: mode
  //     }
  //   })
  // }
  // const mode = jsonEditorModes?.[currentId] || 'table'
  const jsonEditorReadOnly = !isEditable
  return (
    <div className='json-editor-wrapper'>
      <div className={`input-field-editor text-area ${jsonError ? 'error' : ''}`} id='input-field-json'>
        <div className='text-area-header'>
          <div><label>{title}</label>{isRequired ? <span className='mandatory'>*</span> : ''} {tooltipText ? <span id='info-icon'><Tooltip placement='rightTop' childComponent={<div className='info-icon'><InformationIcon /></div>} description={tooltipText} parentCompoent='info-icon' /></span> : null }</div>
          <div className='text-area-icons'>
            <PopoverConfirm warningMessage={'Are you sure you want to clear the field ?'} confirm={() => handleJsonArrayChange(jsonConfig, '')} parentCompoent={parentCompoent} />
            <Icon type='copy' onClick={() => copyOnClick(value, 'JSON ARRAY')} />
          </div>
        </div>
        <p className='json-array-error'>{jsonErrorMessage ? 'Please Enter Valid JSON Array' : ''}</p>
        {/* <TextArea name={inputName} placeholder={placeholder} value={value} onChange={onChange.bind(this, handleChange)} autosize={{ minRows: 2, maxRows: 6 }} maxLength={limit} onClick={onFocus} readOnly={!isEditable} /> */}
      </div>
      <JsonEditor
        // on page load jsonEditorValue key will be undefined, when onchange of editor is called from then onwards jsonEditorValue key will have value, its done like this since json editor needs exact data given by its onchange event (content) in state else undo redo wont work
        content={getJsonEditorArrayValue(jsonEditorValue, value)}
        onChange={(content) => {
          handleChange(content)
        }}
        headerOptionsToRemove={JSON_EDITOR_HEADER_OPTIONS_TO_REMOVE}
        onRenderContextMenu={(items, context) => {
          return handleContextMenuOptions({ items, context, jsonEditorReadOnly })
        }}
        readOnly={jsonEditorReadOnly}
        onChangeMode={(mode) => handleJsonEditorModes(mode, currentId)}
        mode={mode}
      />
      <AddImageModal
        // onChangeModal={(a, b, c, d, f) => console.log('onChangeModal', { a, b, c, d, f })}
        // type={(a, b, c, d, f) => console.log('type', { a, b, c, d, f })}
        isMultiSelect={false}
        isVisible={isImageModalOpen}
        handleCancel={() => setIsImageModalOpen(false)}
        isUpdateDisabled={false}
        handleSubmit={(selectedImage) => {
          // integrate selected image to state
          const fileName = selectedImage?.[0]?.fileName || ''
          const contentCopy = value ? JSON.parse(value) : null
          const valuePath = imagePathDetails.path.join('.')
          set(contentCopy, valuePath, fileName)
          const content = { text: JSON.stringify(contentCopy, null, JSON_EDITOR_INDENTATION) }
          handleChange(content)
          setIsImageModalOpen(false)
        }}
        isSubmitButtonDisabled={false}
        isCancelButtonDisabled={false}
        currentSelection={[]}
        mediaType='IMAGE'
        project={project}
      />

    </div>
  )
}

TextAreaJsonArrayApp.propTypes = {
  /** Change action of TextAreaJsonArrayApp. */
  handleChange: PropTypes.func,
  /** display value of TextAreaJsonArrayApp. */
  value: PropTypes.string,
  /** placeholder of TextAreaJsonArrayApp. */
  placeholder: PropTypes.string.isRequired,
  /** title of TextAreaJsonArrayApp. */
  title: PropTypes.string.isRequired,
  /** input name of TextAreaJsonArrayApp. */
  inputName: PropTypes.string.isRequired,
  /** editable status of TextAreaJsonArrayApp. */
  isEditable: PropTypes.bool,
  /** string limited status of TextAreaJsonArrayApp. */
  isLimited: PropTypes.bool,
  /** string limit of TextAreaJsonArrayApp. */
  limit: PropTypes.number
}

TextAreaJsonArrayApp.defaultProps = {
  isEditable: true
}

export default TextAreaJsonArrayApp
